import Vue from 'vue'
import {
	oauthToken
} from '@/api/user';
// addSchoolUser,
// getUserInfo,


import {
	getAccessToken,
	removeAccessToken,
	setAccessToken
} from '@/utils/accessToken';

import AES from "@/utils/AES.js";

import {
	title,
	tokenName
} from '@/config/setting.config';

import {
	setStorage,
	getStorage
} from '@/utils/index'

import {
	resetRouter
} from '@/router';



const state = {
	accessToken: getAccessToken() || "",
	username: getStorage('username'),
	avatar: '',
	permissions: [],
	ip: '',
	HbnRefreshToken: '',
	HbnExpiresIn: '',
	userInfo: ''
};

const getters = {
	accessToken: (state) => state.accessToken,
	username: (state) => state.username,
	avatar: (state) => state.avatar,
	permissions: (state) => state.permissions,
	ip: (state) => state.ip,
	HbnRefreshToken: (state) => state.HbnRefreshToken,
	HbnExpiresIn: (state) => state.HbnExpiresIn,
	userInfo: (state) => state.userInfo,
};
const mutations = {
	setAccessToken(state, accessToken) {
		state.accessToken = accessToken;
		setAccessToken(accessToken);
	},
	setUsername(state, username) {
		state.username = username;
		setStorage('username', username)
	},
	setAvatar(state, avatar) {
		state.avatar = avatar;
	},
	setPermissions(state, permissions) {
		state.permissions = permissions;
	},
	setIp(state, data) {
		state.ip = data
	},
	setHbnRefreshToken(state, data) {
		document.cookie = `HbnRefreshToken=${data}`;
		state.HbnRefreshToken = data
	},
	setHbnExpiresIn(state, data) {
		state.HbnExpiresIn = data
	},
	setUserInfo(state, data) {
		state.userInfo = data
	},
};
const actions = {
	setPermissions({
		commit
	}, permissions) {
		commit('setPermissions', permissions);
	},
	async login({
		commit
	}, form) {
		let {
			username,
			password
		} = form;
		// AES.encrypt(password) 
		// 'ykppQqkjcArow25KxEM8kw=='
		// password='ykppQqkjcArow25KxEM8kw=='
		password = AES.encrypt(password)
		let formData = {}
		try {
			if (form.is_password) {
				formData = {
					username,
					password: password,
					grant_type: 'password',
					ip: state.ip,
					scope: 'server',
					client: 6,
					isToken: true,
					Authorization: "Basic REJfV0VCOkRCX1dFQg=="
				}

			} else {
				formData = {
					grant_type: 'password',
					ip: state.ip,
					scope: 'server',
					client: 6,
					carsiinfo: AES.encrypt(form['carsi-persistent-uid'])
				}
			}
		} catch (e) {
			//TODO handle the exception
			console.error(e)
		}


		console.log("加密：", password)
		const data = await login(formData);
		console.log(data, data[tokenName], tokenName)
		const accessToken = data[tokenName];
		let user_info = JSON.parse(data.user_info);
		// HbnAccessToken=q4_EbAaWsk_Hhk1ZZTsQOzktuLw; HbnRefreshToken=VaCDp44xIuE3jDwcSD-G6ZzHkgY; HbnExpiresIn=43199
		console.log("user_info：", user_info);
		try {
			if (accessToken) {
				document.cookie = `HbnAccessToken=${data.access_token}`; 
				document.cookie = `HbnExpiresIn=${data.expires_in}`;
				commit('setAccessToken', accessToken);
				commit('setHbnRefreshToken', data.refresh_token);
				commit('setHbnExpiresIn', data.expires_in);
				commit('setUsername', user_info.userLogin.userName);
				 
				const hour = new Date().getHours();
				const thisTime =
					hour < 8
						? '早上好'
						: hour <= 11
							? '上午好'
							: hour <= 13
								? '中午好'
								: hour < 18
									? '下午好'
									: '晚上好'
				Vue.prototype.$baseNotify(`欢迎登录${title}`, `${thisTime}！`)
			} else {
				Vue.prototype.$baseMessage(
					`登录接口异常，未正确返回${tokenName}...`,
					'error'
				)
			}
		} catch (error) {
			console.error(error)
		}
		
	
	},
	async getUserInfo({
		commit,
		state
	}) {
		return
		const {
			data
		} = await getUserInfo({
			client: 5
		});
		if (!data) {
			// ElMessage.error('验证失败，请重新登录...');
			return false;
		}

		let {
			permissions,
		} = data;

		if (permissions && Array.isArray(permissions)) {
			commit('setPermissions', permissions);
			// commit('setUsername', username);
			// commit('setAvatar', avatar);
			return permissions;
		} else {
			// ElMessage.error('用户信息接口异常');
			return false;
		}
	},
	async logout({
		dispatch
	}) {
		// await logout(state.accessToken);
		await dispatch('resetAccessToken');
		await resetRouter();
	},
	resetAccessToken({ 
		commit
	}) {
		console.log("退出")
		commit('setPermissions', []);
		commit('setAccessToken', '');
		commit('setHbnRefreshToken', ''); 
		removeAccessToken();
	},
	// async getIp({
	// 	commit
	// }) {
	// 	const {
	// 		data
	// 	} = await getIp();
	// 	commit('setIp', data);
	// },
};
export default {
	state,
	getters,
	mutations,
	actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js